import $ from 'jquery';
import { clearInputValue, getInputValue } from '../utils/input';
import { matchesCriteria } from '../utils/criteria';
const ELEMENT_SELECTOR = '.js__set-input-value-on-target-value';
export class SetInputValueOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => {
            let $element = $(element);
            if ($element.hasClass('ui dropdown')) {
                $element = $element.find('select');
            }
            const $target = $($element.data('target'));
            $target.on('change', event => {
                this.handleValueChange($(event.target), $element);
            });
            if ($element.data('set-value-on-load')) {
                this.handleValueChange($target, $element);
            }
        });
    }
    static handleValueChange($target, $element) {
        const value = getInputValue($target);
        const { criteriaValue, clearValue, setValue, setDateValueFromTarget, setTimeValueFromTarget, minusDateDays, plusDateDays, setDateTimeTogether, inverseCriteria, clearBeforeSet, } = $element.data();
        const matched = matchesCriteria(criteriaValue, value, inverseCriteria);
        const clear = matchesCriteria(clearValue, value, inverseCriteria);
        const criteriaMatchedIndex = criteriaValue.split(',').indexOf(value);
        this.updateInput($element, matched, clear, setValue?.split(',')[criteriaMatchedIndex], setDateValueFromTarget, setTimeValueFromTarget, minusDateDays, plusDateDays, setDateTimeTogether, clearBeforeSet);
    }
    static updateInput($element, matched, clear, setValue, setDateValueFromTarget, setTimeValueFromTarget, minusDateDays, plusDateDays, setDateTimeTogether, clearBeforeSet) {
        const $parent = $element.closest('.field:not(.js__toggle-element)').length
            ? $element.closest('.field:not(.js__toggle-element)')
            : $element.closest('.js__toggle-element');
        $parent.find('input[type="checkbox"]').prop('checked', clear ? false : matched);
        if (setValue && matched) {
            const $input = $parent.find('input, select, textarea');
            if (clearBeforeSet) {
                clearInputValue($input);
            }
            $input.not('.search').val(setValue);
            $input.closest('.dropdown').dropdown('set selected', setValue);
        }
        if (setDateValueFromTarget && matched) {
            const $dateInput = $parent.find('input[type="date"]');
            if (setDateTimeTogether && setTimeValueFromTarget && !$(setTimeValueFromTarget).val()) {
                $dateInput.val('');
            }
            else {
                if (minusDateDays && $(setDateValueFromTarget).val()) {
                    const date = new Date(String($(setDateValueFromTarget).val()));
                    date.setDate(date.getDate() - Number(minusDateDays));
                    $dateInput.val(date.toISOString().slice(0, 10));
                }
                else if (plusDateDays && $(setDateValueFromTarget).val()) {
                    const date = new Date(String($(setDateValueFromTarget).val()));
                    date.setDate(date.getDate() + Number(plusDateDays));
                    $dateInput.val(date.toISOString().slice(0, 10));
                }
                else {
                    $dateInput.val(String($(setDateValueFromTarget).val()) || '');
                }
            }
            $dateInput.trigger('change');
        }
        if (setTimeValueFromTarget && matched) {
            const $timeInput = $parent.find('input[type="time"]');
            if (setDateTimeTogether && setDateValueFromTarget && !$(setDateValueFromTarget).val()) {
                $timeInput.val('');
            }
            else {
                $timeInput.val($(setTimeValueFromTarget).val() || '');
            }
            $timeInput.trigger('change');
        }
        if (clear) {
            $parent.find('input, select, textarea').val('');
            clearInputValue($element.parent());
        }
    }
}
